import type { ErrorItemEntry } from '@/components/chat/types/types';
import { TIMELINE_STREAM_ERROR } from '@/utils/chatErrors';
import { generateId } from '@/utils/generateId';

/** Timeline error shown after a real transport failure, not before the request. */
export function createOfflineQueryNetworkErrorEntry(position: number): ErrorItemEntry {
  return {
    type: 'error_item',
    id: generateId(),
    content: TIMELINE_STREAM_ERROR.QUERY_NETWORK,
    position,
  };
}
